import React from 'react';
import { IconProps } from '.';

const SvgStore = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M18.791 2.25H5.21l-.154.548-.02.073-.056.204a226.977 226.977 0 0 0-.816 3.031 93.262 93.262 0 0 0-.616 2.479c-.085.367-.157.701-.208.977-.047.255-.089.519-.089.71 0 1.073.354 1.958 1 2.576v8.902h15.5v-8.902c.646-.618 1-1.503 1-2.575a4.33 4.33 0 0 0-.09-.711c-.05-.276-.122-.61-.207-.977a92.918 92.918 0 0 0-.616-2.479 211.406 211.406 0 0 0-.816-3.03l-.056-.205-.174-.621Zm-.541 11.396c-.297.07-.605.104-.917.104a3.382 3.382 0 0 1-2.666-1.304A3.382 3.382 0 0 1 12 13.75a3.382 3.382 0 0 1-2.667-1.304 3.382 3.382 0 0 1-2.666 1.304c-.312 0-.62-.034-.917-.104v6.604h12.5v-6.604ZM5.778 3l-.723-.202.723.202Zm.446 1.206.124-.456h11.303a207.554 207.554 0 0 1 .734 2.735 91.8 91.8 0 0 1 .606 2.436c.083.357.15.67.195.916a6.458 6.458 0 0 1 .062.4l.002.036c0 .737-.237 1.209-.545 1.5-.317.298-.786.477-1.372.477-1.042 0-1.916-.87-1.916-1.977h-1.5c0 1.108-.874 1.977-1.917 1.977-1.043 0-1.917-.87-1.917-1.977h-1.5c0 1.108-.874 1.977-1.916 1.977-.586 0-1.055-.18-1.372-.478-.308-.29-.545-.762-.545-1.5l.002-.035.011-.095c.011-.08.028-.182.05-.305.047-.247.113-.559.196-.916.164-.714.384-1.587.606-2.436.22-.849.442-1.67.609-2.279Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgStore;
